import { Box, Icon, IconSize, Text } from '@bechtel/gds';
import { FC } from 'react';
import { RestrictedLimitComponentProps } from './typed';

const RestrictedLimitComponent: FC<RestrictedLimitComponentProps> = ({ isLocked, limitCount }) => {
  return (
    <Box justifyContent={{ sm: 'center' }} gap={{ sm: '200' }}>
      <Text size="300" family="openSansCondensed" color={limitCount ? 'green.500' : 'red.700'}>
        {limitCount ? <>Limited item {limitCount} </> : isLocked ? <>Restricted Tool</> : ''}
      </Text>
      {limitCount ? (
        <Icon iconStyle="solid" icon="diamond-exclamation" fillColor="orange.500" size={IconSize.XSMALL} />
      ) : isLocked ? (
        <Icon iconStyle="solid" icon="lock" fillColor="red.700" size={IconSize.XSMALL} />
      ) : (
        ''
      )}
    </Box>
  );
};

export default RestrictedLimitComponent;
